import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';
import { PositionSkill } from '../job/postionDrawer/PositionDrawer';
import { isScoreRangeValid } from 'shared-utils';

interface Props {
	positionSkills: PositionSkill[];
	companyName: string;
}

const SkillComparisonBarChart = ({ positionSkills, companyName }: Props) => {
	const userLabel = 'Your current skills';
	const companyLabel = `${String(companyName)}'s required skills`;

	const barChartData = positionSkills.map(ps => ({
		name: ps.name.length > 13 ? ps.name.substring(0, 13) + '...' : ps.name,
		[userLabel]: Math.round(ps.rating) !== -1 ? isScoreRangeValid(Math.round(ps.rating)) : 0,
		[companyLabel]: Math.round(ps.threshold),
	}));

	return (
		<>
			<div className="sm:hidden pr-3">
				<BarChart
					width={380}
					height={300}
					data={barChartData}
					margin={{
						top: 0,
						right: 0,
						bottom: 0,
					}}
					barGap={12}
				>
					<CartesianGrid horizontal={true} vertical={false} strokeDasharray="3 3" />
					<XAxis dataKey="name" tick={{ fontSize: 12, fontWeight: 400 }} />
					<YAxis domain={[0, 100]} />
					<Bar dataKey={userLabel} fill="#7777E799" barSize={18} />
					<Bar dataKey={companyLabel} fill="#FFCC0099" barSize={18} />
				</BarChart>
			</div>

			<div className="mt-2 flex flex-wrap justify-center gap-4 sm:hidden">
				<div className="text-xs font-normal dark:text-[#E4E4EB] text-[#555770]">
					<div className="mr-[6px] inline-block h-[10px] w-[10px] rounded-[99px] bg-[#7777E7]"></div>
					Your current skills
				</div>

				<div className="text-xs font-normal dark:text-[#E4E4EB] text-[#555770]">
					<div className="mr-[6px] inline-block h-[10px] w-[10px] rounded-[99px] bg-[#FFCC00]"></div>
					{`${companyName}'s required skills`}
				</div>
			</div>
		</>
	);
};

export default SkillComparisonBarChart;
